import React from 'react';

import Inscricao from '../../../../../containers/forms/inscricao/Inscricao';

function CompOrder({ setCart, cart, navigation }) {
  const { previous,next } = navigation;
  return (
    <div>
      <div><Inscricao/></div>
      <div>
        <button onClick={previous}>Anterior</button>
        <button onClick={next}>Próximo</button>
      </div>
    </div>
  );
}



export default CompOrder;